<template>
  <div class="filed-container">
    <div class="filed-main filed-main-edit">
      <div class="filed-head">
        <van-nav-bar
          :title="info"
          left-arrow
          :border="false"
          @click-left="onCancal"
        />
      </div>
      <div class="filed-checkCard">
        <div class="filed-card-head">
          <div class="filed-card-title">{{ info }}</div>
          <div class="filed-card-desc">请填写真实且便于他人理解的内容</div>
        </div>
        <van-field
          v-model="filedValue"
          :colon="true"
          :placeholder="getPlaceholder(info)"
          ref="filed"
          autosize
          type="textarea"
          rows="2"
        />
      </div>
    </div>

    <div class="filed-footer">
      <div class="filed-footer-actions">
        <van-button round class="cancel-btn" @click="onCancal">取消</van-button>
        <van-button round type="info" class="save-btn" @click="onClickSave">保存</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Toast } from "vant";
import { updateMatchmakerInfo } from "../api/matchmakerInfo";
export default {
  data() {
    return {
      value: "",
      info: "",
      filedValue: ""
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  methods: {
    // 参考editFiled.vue
    onClickSave(e) {
      if (!this.filedValue) {
        Toast.fail(`${this.info}不能为空`);
        return;
      }
      if (this.value === "contactNumber") {
        let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg_tel.test(this.filedValue)) {
          Toast.fail({
            message: "请输入正确的手机号",
            className: "phoneErrMessage"
          });
          return;
        }
      }
      let data = JSON.parse(JSON.stringify(this.baseInfo));
      data[this.value] = this.filedValue;
      updateMatchmakerInfo(data).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", res.data);
          Toast.success({
            message: "保存成功",
            className: "interestsErrMessage"
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 300);
        }
      });
    },
    getPlaceholder(value) {
      return "请输入" + value;
    },
    onCancal() {
      this.$router.go(-1);
    },
    getBasicInfo(data) {
      const value = this.$route.params.name;
      this.filedValue = data[value];
      this.value = value;
      switch (value) {
        case "department":
          this.info = "部门";
          break;
        case "contactNumber":
          this.info = "联系方式";
          break;
        case "personalStrength":
          this.info = "个人特长";
          break;
        case "selfIntroduction":
          this.info = "自我介绍";
          break;
        default:
          break;
      }
    }
  },

  mounted() {
    this.$refs.filed;
    this.$refs.filed.focus();
  },
  created() {
    if (this.$route.params.name) {
      let data = JSON.parse(JSON.stringify(this.baseInfo));
      this.getBasicInfo(data);
    }
  }
};
</script>
<style scoped lang="less" src="../style/editFiled.less" />



// WEBPACK FOOTER //
// src/views/editMatchFiled.vue